/**
 * @description 是否 idCard 格式
 * @param {String} string
 * @returns {Boolean}
 */
export const formatIdCard = (string: string): boolean => /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/.test(String(string))
